import { lazy } from '../../../shared/deployment';

export const SocialShareRead = lazy(() => import('./social-share-read/SocialShareRead'));
export const SocialShareCreate = lazy(() => import('./social-share-create/SocialShareCreate'));
